import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { useStyles } from './styles';

const RadioBtnTabsMenu = ({ tabs, activeTab, activeSubTab, change }) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const selectedTab = tabs[activeTab];
  const subTabs = selectedTab.subTabs;

  if (subTabs && subTabs.length) {
    return (
      <div className={classes.container}>
        <Typography variant="h1" className={classes.title}>
          {t(selectedTab.name)}
        </Typography>

        <RadioGroup
          aria-label="sub-tabs"
          name="sub-tabs"
          value={activeSubTab}
          onChange={change}
          className={classes.radioGroup} 
          
        >
          {subTabs.map((subTab, index) => (
            <FormControlLabel
              className={classes.label}
              key={index}
              control={
                <Radio
                  color="default"
                  classes={{
                    root: classes.rootCheckbox,
                    checked: classes.checked
                  }}
                />
              }
              value={index}
              label={
                <div>
                  <Typography
                    className={classNames(classes.labelName, {
                      [classes.checkedLabel]: index === activeSubTab
                    })}
                  >
                    {t(subTab.title)}
                  </Typography>
                  <Typography className={classes.labelInstruction}>
                    {t(subTab.instruction)}
                  </Typography>
                </div>
              }
            />
          ))}
        </RadioGroup>
      </div>
    );
  }

  return false;
};

export default RadioBtnTabsMenu;
